module.exports = __webpack_public_path__ + "media/sound_success.59364894.mp3";